module.exports = __webpack_public_path__ + "img/speed-ok.40f022bc.png";